<div class="header">
    <h2>Modifica <strong>Ispezione</strong></h2>
    <div class="breadcrumb-wrapper hidden-xs">
        <ol class="breadcrumb">
            <li><a routerLink="/inspection-general">Gestione Ispezioni</a></li>
            <li class="active">Modifica Ispezione</li>
        </ol>
    </div>
</div>
<div class="row">
    <div class="col-lg-12 portlets">
        <div class="panel">
            <div class="panel-content" style="padding-top: 40px; padding-bottom: 40px;">
                <form (ngSubmit)="onSubmit()" #inspectionCreateForm="ngForm" role="form" class="form-horizontal form-validation">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="panel">
                                <div class="panel-header bg-dark">
                                    <h3><i class="fa fa-list"></i>Informazioni <strong>Ispezione</strong></h3>
                                </div>
                                <div class="panel-content">
                                    <div class="form-group">
                                        <label for="pa" class="col-sm-3 control-label">PA</label>
                                        <div class="col-sm-9">
                                            <select class="form-control"
                                                    name="pa"
                                                    id="pa"
                                                    style="width:100%;"
                                                    [(ngModel)]="inspection.fk_id_pa"
                                                    (change)="onPAChange()">
                                                <option [ngValue]="" disabled selected>Seleziona Fornitore...</option>
                                                <option [ngValue]="-1">-- CREA NUOVA PA --</option>
                                                <option *ngFor="let pa of pas"
                                                        [ngValue]="pa.id_pa">{{ pa.name }}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label for="contract" class="col-sm-3 control-label">Convenzione *</label>
                                        <div class="col-sm-9">
                                            <select class="form-control"
                                                    name="contract"
                                                    id="contract"
                                                    style="width:100%;"
                                                    required
                                                    [(ngModel)]="inspection.fk_id_contract">
                                                <option [ngValue]="" disabled selected>Seleziona Convenzione...</option>
                                                <option *ngFor="let contract of contracts"
                                                        [ngValue]="contract.id_contract">{{ contract.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6">
                            <div class="panel">
                                <div class="panel-header bg-dark">
                                    <h3><i class="fa fa-list"></i>Informazioni <strong>PA</strong></h3>
                                </div>
                                <div class="panel-content">
                                    <div class="form-group">
                                        <label for="compartment" class="col-sm-3 control-label">Comparto</label>
                                        <div class="col-sm-9 prepend-icon">
                                            <input type="text"
                                                   id="compartment"
                                                   name="compartment"
                                                   class="form-control"
                                                   placeholder="Inserisci Comparto PA..."
                                                   autocomplete="off"
                                                   [(ngModel)]="inspection.pa.compartment">
                                            <i class="fa fa-file"></i>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="name" class="col-sm-3 control-label">Ragione Sociale *</label>
                                        <div class="col-sm-9 prepend-icon">
                                            <input type="text"
                                                   id="name"
                                                   name="name"
                                                   class="form-control"
                                                   placeholder="Inserisci Ragione Sociale PA..."
                                                   autocomplete="off"
                                                   required
                                                   [ngClass]="{
                                                        'form-error': !(name.valid || name.pristine),
                                                        'form-success': name.valid
                                                   }"
                                                   [(ngModel)]="inspection.pa.name"
                                                   #name="ngModel">
                                            <i class="fa fa-file"></i>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="address" class="col-sm-3 control-label">Indirizzo</label>
                                        <div class="col-sm-9 prepend-icon">
                                            <input type="text"
                                                   id="address"
                                                   name="address"
                                                   class="form-control"
                                                   placeholder="Inserisci Indirizzo PA..."
                                                   autocomplete="off"
                                                   [(ngModel)]="inspection.pa.address">
                                            <i class="fa fa-file"></i>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="house_number" class="col-sm-3 control-label">Numero Civico</label>
                                        <div class="col-sm-9 prepend-icon">
                                            <input type="text"
                                                   id="house_number"
                                                   name="house_number"
                                                   class="form-control"
                                                   placeholder="Inserisci Numero Civico PA..."
                                                   autocomplete="off"
                                                   [(ngModel)]="inspection.pa.house_number">
                                            <i class="fa fa-file"></i>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="cap" class="col-sm-3 control-label">CAP</label>
                                        <div class="col-sm-9 prepend-icon">
                                            <input type="number"
                                                   id="cap"
                                                   name="cap"
                                                   class="form-control"
                                                   placeholder="Inserisci CAP PA..."
                                                   autocomplete="off"
                                                   [(ngModel)]="inspection.pa.cap">
                                            <i class="fa fa-file"></i>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="municipality" class="col-sm-3 control-label">Comune</label>
                                        <div class="col-sm-9 prepend-icon">
                                            <input type="text"
                                                   id="municipality"
                                                   name="municipality"
                                                   class="form-control"
                                                   placeholder="Inserisci Comune PA..."
                                                   autocomplete="off"
                                                   [(ngModel)]="inspection.pa.municipality">
                                            <i class="fa fa-file"></i>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="province" class="col-sm-3 control-label">Provincia</label>
                                        <div class="col-sm-9 prepend-icon">
                                            <input type="text"
                                                   id="province"
                                                   name="province"
                                                   class="form-control"
                                                   placeholder="Inserisci Provincia PA..."
                                                   autocomplete="off"
                                                   [(ngModel)]="inspection.pa.province">
                                            <i class="fa fa-file"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="text-center m-t-20">
                        <button type="submit"
                                class="btn btn-embossed btn-primary"
                                [disabled]="!((inspection.fk_id_pa !== 0 || inspection.pa.name !== '') && inspection.fk_id_contract !== 0)">
                            <i class="icon-pencil"></i> Modifica Ispezione
                        </button>
                    </div>

                    <div [hidden]="inspectionUpdateResult" class="alert alert-danger">
                        Si è verificato un errore nella modifica dell'ispezione, riprovare.
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
